import SingleFilter from 'components/SingleFilter';
import TableNavigator from 'components/TableNavigator';
import VHS_EPISODES_SORTING from 'constants/VHS_EPISODES_SORTING';
import useActions from 'hooks/useActions';
import { useEffect } from 'react';
import EpisodesTable from 'routing/vhs/Episodes/EpisodesTable';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        episodes: state.vhsSeries.episodes,
        isLoading: state.vhsSeries.isLoadingEpisodes,
        page: state.vhsSeries.episodes_page,
        per_page: state.vhsSeries.episodes_per_page,
        total_pages: state.vhsSeries.episodes_total_pages,
        series: state.vhsSeries.selectedSeries,
        episodesOrder: state.vhsSeries.episodesOrder,
    };
}

const SeriesEpisodes = connect(mapStateToProps)(function (props) {
    const {
        episodes,
        page,
        per_page,
        total_pages,
        series,
        episodesOrder,
        isLoading,
    } = props;

    const {
        VHS_FETCH_SERIES_EPISODES_REQUEST,
        VHS_SELECT_SERIES_EPISODES_ORDER,
    } = useActions();

    const onNextPage = () => {
        VHS_FETCH_SERIES_EPISODES_REQUEST({
            seriesId: series?.id,
            per_page,
            page: page + 1,
            order: episodesOrder,
        });
    };

    const onPrevPage = () => {
        VHS_FETCH_SERIES_EPISODES_REQUEST({
            seriesId: series?.id,
            per_page,
            page: page - 1,
            order: episodesOrder,
        });
    };

    const onPageSelect = (pageSelected) => {
        VHS_FETCH_SERIES_EPISODES_REQUEST({
            seriesId: series?.id,
            per_page,
            page: pageSelected,
            order: episodesOrder,
        });
    };

    const onPerPageSelected = (perPage) => {
        VHS_FETCH_SERIES_EPISODES_REQUEST({
            seriesId: series?.id,
            per_page: perPage,
            order: episodesOrder,
        });
    };

    useEffect(() => {
        VHS_FETCH_SERIES_EPISODES_REQUEST({
            seriesId: series?.id,
            per_page: per_page,
            order: episodesOrder,
        });
        // eslint-disable-next-line
    }, [episodesOrder]);

    return (
        <section>
            <div className="flex mb-4">
                <div className="flex-1 font-bold cursor-pointer text-lg">
                    Episodes
                </div>
                <SingleFilter
                    selectedValue={per_page}
                    options={[
                        { value: 10, label: '10 Per Page' },
                        { value: 30, label: '30 Per Page' },
                        { value: 100, label: '100 Per Page' },
                    ]}
                    onSelect={onPerPageSelected}
                />
                <SingleFilter
                    selectedValue={episodesOrder}
                    options={VHS_EPISODES_SORTING}
                    onSelect={(value) =>
                        VHS_SELECT_SERIES_EPISODES_ORDER(value)
                    }
                />
            </div>
            <EpisodesTable episodes={episodes} isLoading={isLoading} />
            <TableNavigator
                currentPage={page}
                totalPages={total_pages}
                onNext={onNextPage}
                onPrev={onPrevPage}
                onPageSelected={onPageSelect}
            />
        </section>
    );
});

export default SeriesEpisodes;
